import {theme} from "./Tema";

//export const NUMEROWASS = '3004627579'

export const TIEMPOACTIVACIONCONTRATO = 1000 * 60 * 60 * 24 * 2


export const NUMEROWASS = '3128911448'

export const ESTADOSCONTRATO = [
    {
        nombre: 'Activo',
        color: theme.palette.primary.main
    },

    {
        nombre: 'No Rendimientos',
        color: theme.palette.primary.main
    },
    {
        nombre: 'No Bonos',
        color: '#808080'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
    {
        nombre: 'Duplicado',
        color: '#279c00'
    },
]

export const ESTADOSCUENTA = [
    {
        nombre: 'Aceptado',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]

export const ESTADOSDEPOSITOS = [
    {
        nombre: 'Aceptado',
        color: theme.palette.primary.main
    },

    {
        nombre: 'Rechazado',
        color: '#808080'
    },
    {
        nombre: 'Validando',
        color: '#808080'
    },
]


export const ESTADOCONTRATOS = [
    {
        nombre: 'Aceptado',
        color: theme.palette.primary.main
    },

    {
        nombre: 'Completado',
        color: '#808080'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]

export const VISIBILIDADMOVIMIENTO = [
    {
        nombre: 'Visible',
        color: theme.palette.primary.main
    },

    {
        nombre: 'No Visible',
        color: '#808080'
    }
]

export const ESTADOSSOPORTE = [
    {
        nombre: 'Abierto',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Cerrado',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Contactando',
        color: theme.palette.info.main
    },
]

export const TIPOSMOVIMIENTO = ['Deposito', 'Bonos', 'Rendimientos','Puntos']

export const ESTADOSMOVIMIENTO = ['Aceptado', 'Validando',]

export const TIPOMONEDA = ['USD', 'USDT RED (TRC20)', 'LTC RED (LITECOIN)', 'PUNTOS']


//export const TIPOSMOVIMIENTO = ['Deposito', 'Bonos', 'Rendimientos','Puntos']

export const TIPOSCONTRATO = [
    {
        nombre: 'Bono',
        color: '#808080'
    },
    {
        nombre: 'Rendimientos',
        color: '#808080'
    },
    {
        nombre: 'Puntos',
        color: '#808080'
    },
]


export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]


export const CRYPTOS = [
    {
        nombre: 'USDT RED (TRC20)',
        key: 'TXLxsE1oQN4EW9P8mosvpnx2GbyoG2hVkv',

    }, {
        nombre: 'LTC RED (LITECOIN)',
        key: 'ltc1qz5tm8ae7w6psnxk7nel5l9mmx7w56ulgu0u6rv',

    }
]

export const TIPOSRETIRO = [
    {
        nombre: 'Premium',
        descripcion: 'Comisión del 14%, con procesamiento entre 16 a 32 horas.',
        corta: '(Premium) comision 14%',
        porcentaje: 14
    },
    {
        nombre: 'Standard',
        descripcion: 'Comisión del 10%, con procesamiento entre 24 a 72 horas.',
        corta: '(Standard) comision 10%',
        porcentaje: 10
    },
]
